"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImageSrc = exports.getImage360Src = exports.IMAGE_SIZE = void 0;
var _productFallback = _interopRequireDefault(require("b2b-components/core/assets/images/product-fallback.svg"));
var IMAGE_SIZE = /*#__PURE__*/function (IMAGE_SIZE) {
  IMAGE_SIZE["full"] = "full";
  IMAGE_SIZE["preview"] = "preview";
  IMAGE_SIZE["thumbnail"] = "thumbnail";
  return IMAGE_SIZE;
}(IMAGE_SIZE || {});
exports.IMAGE_SIZE = IMAGE_SIZE;
var getImageSrc = function getImageSrc(image, imageUrl, imageSize) {
  return image[imageSize] ? "".concat(imageUrl).concat(image[imageSize]) : _productFallback["default"];
};
exports.getImageSrc = getImageSrc;
var getImage360Src = function getImage360Src(image360, imageUrl, images) {
  var imageThumbnail = images && images[0] && images[0][IMAGE_SIZE.thumbnail];
  return "".concat(imageUrl).concat(imageThumbnail || image360.base[0]);
};
exports.getImage360Src = getImage360Src;